import { inputCls } from "../input-class";

/** STRING fallback control — also handles `email` / `phone` keys with
 *  the matching native input type so mobile keyboards swap to the
 *  email / tel layout. */
export function StringControl({
  id,
  fieldKey,
  value,
  disabled,
  onChange,
}: {
  id: string;
  fieldKey: string;
  value: string | null;
  disabled?: boolean;
  onChange: (next: string | null) => void;
}) {
  const type = fieldKey === "email" ? "email" : fieldKey === "phone" ? "tel" : "text";
  const autoComplete =
    fieldKey === "email"
      ? "email"
      : fieldKey === "phone"
        ? "tel"
        : fieldKey === "firstName"
          ? "given-name"
          : fieldKey === "lastName"
            ? "family-name"
            : undefined;
  return (
    <input
      id={id}
      type={type}
      value={value ?? ""}
      disabled={disabled}
      autoComplete={autoComplete}
      placeholder={fieldKey === "phone" ? "+1 555 123 4567" : undefined}
      onChange={(e) => onChange(e.target.value || null)}
      className={inputCls}
    />
  );
}
